const SOLO = process.env.REACT_APP_PLAN_SOLO_ID!;
const DUO = process.env.REACT_APP_PLAN_DUO_ID!;
const TRIO = process.env.REACT_APP_PLAN_TRIO_ID!;
const SQUAD = process.env.REACT_APP_PLAN_SQUAD_ID!;
const STUDIO = process.env.REACT_APP_PLAN_STUDIO_ID!;
const TEAM = process.env.REACT_APP_PLAN_TEAM_ID!;
const ENTERPRISE = process.env.REACT_APP_PLAN_ENTERPRISE_ID!;
const FRONT_DESK = process.env.REACT_APP_PLAN_FRONT_DESK_ID;

export const planIdMap = {
  solo: SOLO,
  duo: DUO,
  trio: TRIO,
  squad: SQUAD,
  studio: STUDIO,
  team: TEAM,
  enterprise: ENTERPRISE,
  frontDesk: FRONT_DESK,
};

export const planNameMap: Record<string, string> = {
  [SOLO]: 'Solo Plan',
  [DUO]: 'Duo Plan',
  [TRIO]: 'Trio Plan',
  [SQUAD]: 'Squad Plan',
  [STUDIO]: 'Studio Plan',
  [TEAM]: 'Team Plan',
  [ENTERPRISE]: 'Enterprise Plan',
  ...(FRONT_DESK ? { [FRONT_DESK]: 'Front Desk Mode' } : {}),
};

export const employeeCountMap: Record<string, number> = {
  [SOLO]: 1,
  [DUO]: 2,
  [TRIO]: 3,
  [SQUAD]: 4,
  [STUDIO]: 5,
  [TEAM]: 10,
  [ENTERPRISE]: 25,
  ...(FRONT_DESK ? { [FRONT_DESK]: 1 } : {}),
};

export const frontDeskPlan = FRONT_DESK
  ? {
      title: 'Front Desk Mode',
      price: '$60/mo',
      id: FRONT_DESK,
      features: [
        '1 admin login included',
        'Orchestrator mode enabled by default',
        'Auto-assign bookings to any eligible employee',
        'Primary orchestrator notifications enabled',
      ],
    }
  : null;

export const plans = [
  {
    title: 'Solo',
    price: '$25/mo',
    id: SOLO,
    features: [
      'Includes 1 employee',
      'SMS confirmations for customers and employees',
      'Email notifications',
      'Custom booking website',
      'Custom domain (yourname.scheduify.com)',
    ],
  },
  {
    title: 'Duo',
    price: '$50/mo',
    id: DUO,
    features: [
      'Includes 2 employees',
      'SMS confirmations for customers and employees',
      'Email notifications',
      'Custom booking website',
      'Custom domain (yourname.scheduify.com)',
    ],
  },
  {
    title: 'Trio',
    price: '$75/mo',
    id: TRIO,
    features: [
      'Includes up to 3 employees',
      'SMS confirmations for customers and employees',
      'Email notifications',
      'Custom booking website',
      'Custom domain (yourname.scheduify.com)',
    ],
  },
  {
    title: 'Squad',
    price: '$100/mo',
    id: SQUAD,
    features: [
      'Includes up to 4 employees',
      'SMS confirmations for customers and employees',
      'Email notifications',
      'Custom booking website',
      'Custom domain (yourname.scheduify.com)',
    ],
  },
  {
    title: 'Studio',
    price: '$120/mo',
    id: STUDIO,
    features: [
      'Includes up to 5 employees',
      'SMS confirmations for customers and employees',
      'Email notifications',
      'Custom booking website',
      'Custom domain (yourname.scheduify.com)',
    ],
  },
  {
    title: 'Team',
    price: '$200/mo',
    id: TEAM,
    features: [
      'Includes up to 10 employees',
      'SMS confirmations for customers and employees',
      'Email notifications',
      'Custom booking website',
      'Custom domain (yourname.scheduify.com)',
    ],
  },
  {
    title: 'Enterprise',
    price: '$500/mo',
    id: ENTERPRISE,
    features: [
      'Includes 25 employees',
      'SMS confirmations for customers and employees',
      'Email notifications',
      'Custom booking website',
      'Custom domain (yourname.scheduify.com)',
      'Priority support',
    ],
  },
];

export function isDowngrade(currentPlanId: string | undefined, newPlanId: string): boolean {
  if (!currentPlanId) return false;

  const planOrder = plans.map((plan) => plan.id);
  const currentIndex = planOrder.indexOf(currentPlanId);
  const newIndex = planOrder.indexOf(newPlanId);

  if (currentIndex === -1 || newIndex === -1) return false;

  return newIndex < currentIndex;
}
